<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-sheet class="neu-glow with-radius">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="12" class="px-5 pos-relative">
                  <div class="mt-8 text-center">
                    <div class="text-h4">Reset My Password</div>
                  </div>

                  <v-form
                    @submit.prevent="$v.$invalid ? null : submit()"
                    ref="form"
                    class="my-10"
                    v-if="!resetted"
                  >
                    <v-text-field
                      :error-messages="fieldErrors('email')"
                      @input="$v.email.$touch()"
                      @blur="$v.email.$touch()"
                      prepend-inner-icon="email"
                      v-model="email"
                      label="Email"
                      solo
                      flat
                    />

                    <v-btn
                      block
                      type="submit"
                      :disabled="$v.$invalid"
                      :loading="loader"
                      >Reset Password</v-btn
                    >
                  </v-form>
                  <div v-else>
                    <v-card class="mt-5 mb-5">
                      <v-card-text class="success text-center" style="color: white">
                        <h3>
                          Success. Please login with the temporary password sent to your email. 
                        </h3>
                      </v-card-text>
                    </v-card>

                    <v-btn @click="resetted = false">New Reset Password</v-btn>
                  </div>

                  <v-btn
                    icon
                    absolute
                    top
                    right
                    to="/pages/authentication/login"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>Password Reset Successfully</span>
      <v-icon dark>check_circle</v-icon>
    </v-snackbar>
  </v-sheet>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
  },
  validationMessages: {
    email: {
      required: "Please enter email",
      email: "Email must be valid",
    },
  },
  data() {
    return {
      resetted: false,
      errors: null,
      email: null,
      loader: false,
    };
  },
  computed: {
    ...mapState({
      status : (state) => state.account.status
    })
  },
  methods: {
    ...mapActions({
      requestPassword: "account/requestPassword",
    }),
    async submit() {
      this.loader = true;
      await this.requestPassword(this.email);
      if (!this.status.error) {
        this.resetted = true;
      } else {
        this.resetted = false;
      }
      this.loader = false;
      
    },
  },
};
</script>
